// extracted by mini-css-extract-plugin
export var filterIncDec = "_ag-0";
export var leftBorder = "_ag-1";
export var rightBorder = "_ag-2";
export var stringInput = "_ag-3";